import { render, staticRenderFns } from "./paese_select.vue?vue&type=template&id=683a7cd4&scoped=true&"
import script from "./paese_select.vue?vue&type=script&lang=js&"
export * from "./paese_select.vue?vue&type=script&lang=js&"
import style0 from "./paese_select.vue?vue&type=style&index=0&id=683a7cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a7cd4",
  null
  
)

export default component.exports